import { getDocument } from '../pdf/pdfjs';

export const hasAttachmentValidPdfStructure = async (src: string | ArrayBuffer): Promise<boolean> => {
  const loadingTask = getDocument(src);

  try {
    const pdfDocument = await loadingTask.promise;
    return !!pdfDocument.numPages;
  } catch {
    return false;
  } finally {
    await loadingTask.destroy().catch(() => {});
  }
};
